import React from 'react';
import { bool, func, instanceOf, number, string } from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import IconMoreHorz from '../../../shared/icons/IconMoreHorz';
import { DISTRIBUTE_CANCEL_STATUS } from '../../../shared/DEConstants';

const ContextMenu = ({ row, onClick, setHoverIndex, rowIndex, status, impersonated = false }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
    setHoverIndex(rowIndex);
  };

  const handleClose = (eventType = '') => {
    setAnchorEl(null);
    if(eventType !== 'delete'){
      setHoverIndex(null);
    }
  };

  const _handleOptionClick = (event, name) => {
    handleClose(name);
    onClick(row, name);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  return (
    <div className="de--label--context-menu">
      <IconButton
        aria-describedby={id}
        className="de--label-table-body-row-rightCol__actions--button"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <IconMoreHorz />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className="de--label--context-popover"
      >
        <div className="de--label--context-root">
          <button
            type="button"
            onClick={e => _handleOptionClick(e, 'open')}
            className="de--label--context-item"
            data-test="editlabel"
          >
            <span>Open</span>
          </button>
          {DISTRIBUTE_CANCEL_STATUS.includes(status) && !impersonated && (
            <button
              type="button"
              onClick={e => _handleOptionClick(e, 'cancel')}
              className="de--label--context-item"
              data-test="cancel"
            >
              <span>Cancel</span>
            </button>
          )}
          { row.allowedToDelete === 0 && !impersonated && (
            <button
              type="button"
              onClick={e => _handleOptionClick(e, 'delete')}
              className="de--label--context-item color-red"
              data-test="delete"
            >
              <span>Delete</span>
            </button>
          )}
          {/* <button
            type="button"
            onClick={e => _handleOptionClick(e, 'createCopy')}
            className="de--label--context-item"
            data-test="restorelabel"
          >
            <span>Create Copy</span>
          </button>
          <button
            type="button"
            onClick={e => _handleOptionClick(e, 'distribute')}
            className="de--label--context-item"
            data-test="restorelabel"
          >
            <span>Distribute</span>
          </button>
          <button
            type="button"
            onClick={e => _handleOptionClick(e, 'remove')}
            className="de--label--context-item"
            data-test="restorelabel"
          >
            <span>Remove</span>
          </button> */}
        </div>
      </Popover>
    </div>
  );
};

ContextMenu.propTypes = {
  row: instanceOf(Object),
  onClick: func,
  setHoverIndex: func,
  rowIndex: number,
  status: string,
  impersonated: bool,
};

export default ContextMenu;
